import React from "react";
import {OrbitComponent} from "../base-components/orbit-component/orbit-component";
import {LiveStreamingSoundButtonBox} from "./boxes/live-streaming-sound-button/live-streaming-sound-button.box";

export class LiveStreamingSoundButtonComponent extends OrbitComponent {
    private _renderIcon() {

        if (this.services.httpLiveStream.isVideoMuted) {
            const MuteIcon = this.services.theme.currentTheme.icons.muteIcon;
            return <MuteIcon size={2.5}/>;
        }

        const UnmuteIcon = this.services.theme.currentTheme.icons.unmuteIcon;
        return <UnmuteIcon size={2.5}/>;
    }

    private _handleClick() {
        this.services.httpLiveStream.toggleVideoSound();
    }

    render() {
        return (
            <LiveStreamingSoundButtonBox onClick={() => this._handleClick()}>
                {this._renderIcon()}
            </LiveStreamingSoundButtonBox>
        );
    }
}
